const service = 'service-ltm-cancellation';
export const getConfig = (api, payload) => api.rpc(service, '1/2021-09-21/config', payload);
export const quoteCancellation = (api, payload) => api.rpc(service, '1/2021-09-21/quote_cancellation', payload);
export const quoteAutocycle = (api, payload) => api.rpc(service, '1/2021-09-21/quote_autocycle', payload);
export const confirmCancellation = (api, payload) => api.rpc(service, '1/2021-09-21/confirm_cancellation', payload);
